var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewFromShore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0.75H2.25C1.42157 0.75 0.75 1.42157 0.75 2.25V21.75C0.75 22.5784 1.42157 23.25 2.25 23.25H21.75C22.5784 23.25 23.25 22.5784 23.25 21.75V2.25C23.25 1.42157 22.5784 0.75 21.75 0.75Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26705 10.722C3.93596 11.0627 3.75073 11.519 3.75073 11.994C3.75073 12.4691 3.93596 12.9254 4.26705 13.266C5.81805 14.821 8.59105 17.25 12.0001 17.25C15.4091 17.25 18.1831 14.822 19.7351 13.267C20.0661 12.9264 20.2514 12.4701 20.2514 11.995C20.2514 11.52 20.0661 11.0637 19.7351 10.723C18.1821 9.16801 15.4061 6.73901 12.0001 6.73901C8.59405 6.73901 5.81905 9.16601 4.26705 10.722Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.241C13.2426 14.241 14.25 13.2336 14.25 11.991C14.25 10.7483 13.2426 9.74097 12 9.74097C10.7574 9.74097 9.75 10.7483 9.75 11.991C9.75 13.2336 10.7574 14.241 12 14.241Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFromShore);
export default __webpack_public_path__ + "static/media/ViewFromShore.97fc74d3d48cee8e165890c8970f69f2.svg";
export { ForwardRef as ReactComponent };